import { render, staticRenderFns } from "./Slogin.vue?vue&type=template&id=95d3a682&scoped=true"
import script from "./Slogin.vue?vue&type=script&lang=js"
export * from "./Slogin.vue?vue&type=script&lang=js"
import style0 from "./Slogin.vue?vue&type=style&index=0&id=95d3a682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d3a682",
  null
  
)

export default component.exports